<template>
  <div>
    <div
      v-if="loader === 100"
      class="estatisticas-dashboard"
    >
      <!-- Toolbar de filtros -->
      <div class="dash-toolbar">
        <button
          class="dash-btn dash-btn-ghost"
          @click="setSemana()"
        >
          Semanal
        </button>
        <button
          class="dash-btn dash-btn-ghost"
          @click="setAno()"
        >
          30 Dias
        </button>
        <div class="dash-field">
          <label>Data inicial</label>
          <input
            v-model="pesquisa.data_inicio"
            type="date"
            class="dash-input form-control"
          >
        </div>
        <div class="dash-field">
          <label>Data final</label>
          <input
            v-model="pesquisa.data_fim"
            type="date"
            class="dash-input form-control"
          >
        </div>
        <div class="dash-spacer" />
        <button
          class="btn btn-primary"
          @click="getEstatisticas()"
        >
          <i class="fas fa-search" /> Buscar
        </button>
        <button
          class="dash-btn dash-btn-danger"
          :disabled="!temDados"
          @click="getPdf()"
        >
          <i class="fas fa-file-pdf" /> PDF
        </button>
        <button
          class="dash-btn dash-btn-success"
          :disabled="!temDados"
          @click="getExcel()"
        >
          <i class="fas fa-file-excel" /> Excel
        </button>
      </div>

      <div
        v-if="carregando"
        class="dash-loading"
      >
        <div class="dash-spinner" />
        <p>Gerando relatório…</p>
      </div>

      <template v-else-if="temDados">
        <!-- Cabeçalho -->
        <div class="dash-header">
          <div>
            <h1>Dashboard operacional</h1>
            <p>Sistema de gestão de senhas — área da saúde</p>
          </div>
          <div class="dash-header-date">
            <span>Período</span>
            <strong>{{ periodoFormatado }}</strong>
          </div>
        </div>

        <!-- Cards do topo -->
        <div class="kpi-grid">
          <div class="kpi-card kpi-total">
            <span class="kpi-label">Total emitidas</span>
            <span class="kpi-value">{{ dashboard.cards.total_emitidas }}</span>
          </div>
          <div class="kpi-card kpi-fila">
            <span class="kpi-label">Senhas em fila</span>
            <span class="kpi-value">{{ dashboard.cards.em_fila }}</span>
          </div>
          <div class="kpi-card kpi-ausentes">
            <span class="kpi-label">Ausentes</span>
            <span class="kpi-value">{{ dashboard.cards.ausentes }}</span>
          </div>
          <div class="kpi-card kpi-jornada">
            <span class="kpi-label">Tempo médio total da jornada</span>
            <span class="kpi-value">{{ dashboard.cards.tempo_medio_jornada }}</span>
          </div>
        </div>

        <!-- Grade principal -->
        <div class="dash-grid">
          <section class="panel">
            <h2>Tempos médios de espera</h2>
            <table class="tempos-table">
              <thead>
                <tr>
                  <th>Setor</th>
                  <th>Tempo</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(setor, indice) in dashboard.setores"
                  :key="'setor-' + indice"
                >
                  <td>{{ setor.nome }}</td>
                  <td class="col-tempo">
                    {{ setor.tempo }}
                  </td>
                  <td>
                    <span
                      class="pill"
                      :class="classeStatus(setor.status)"
                    >{{ rotuloStatus(setor.status) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <div class="dash-col">
            <section class="panel">
              <h2>Perfil de demanda</h2>
              <p
                v-if="!dashboard.perfil_demanda.length"
                class="panel-empty"
              >
                Sem dados no período.
              </p>
              <div
                v-for="(demanda, indice) in dashboard.perfil_demanda"
                :key="'demanda-' + indice"
                class="demanda-item"
              >
                <div class="demanda-top">
                  <span class="nome">{{ demanda.nome }}</span>
                  <span class="qtd">{{ demanda.qtd }}</span>
                </div>
                <div class="bar-track">
                  <div
                    class="bar-fill"
                    :style="{ width: demanda.percentual + '%' }"
                  />
                </div>
              </div>
            </section>

            <section class="panel">
              <h2>Perfil de prioridades</h2>
              <p
                v-if="!dashboard.perfil_prioridades.length"
                class="panel-empty"
              >
                Sem dados no período.
              </p>
              <div
                v-for="(prioridade, indice) in dashboard.perfil_prioridades"
                :key="'prioridade-' + indice"
                class="prioridade-item"
              >
                <span>{{ prioridade.nome }}</span>
                <span class="qtd">{{ prioridade.qtd }}</span>
              </div>
            </section>
          </div>
        </div>

        <!-- Situação dos atendimentos -->
        <section class="panel">
          <h2>Situação dos atendimentos</h2>
          <div class="situacao-grid">
            <div class="situacao-tile tile-pendentes">
              <span class="tile-label">Senhas pendentes</span>
              <span class="tile-value">{{ dashboard.situacao.pendentes }}</span>
            </div>
            <div class="situacao-tile tile-evadidas">
              <span class="tile-label">Evadidas</span>
              <span class="tile-value">{{ dashboard.situacao.evadidas }}</span>
            </div>
            <div class="situacao-tile tile-finalizados">
              <span class="tile-label">Finalizados</span>
              <span class="tile-value">{{ dashboard.situacao.finalizados }}</span>
            </div>
            <div class="situacao-tile tile-cancelados">
              <span class="tile-label">Cancelados</span>
              <span class="tile-value">{{ dashboard.situacao.cancelados }}</span>
            </div>
          </div>
        </section>
      </template>

      <div
        v-else
        class="dash-empty"
      >
        Selecione um período e clique em <strong>Buscar</strong> para gerar o relatório.
      </div>
    </div>

    <div
      v-else
      class="row justify-content-center mt-3"
    >
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
        <b style="font-size: 14pt">Carregando</b><br>
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  name: 'EstatisticasSenhas',
  components: {
    BaseCrud,
    vSelect,
  },
  data() {
    return {
      configuracao: [],
      loader: 0,
      dashboard: null,
      carregando: false,
      pesquisa: {
        data_inicio: '',
        data_fim: '',
      },
    }
  },
  computed: {
    temDados() {
      return this.dashboard !== null
    },
    periodoFormatado() {
      if (!this.dashboard) {
        return ''
      }
      const inicio = this.formatarDataBr(this.dashboard.periodo.data_inicio)
      const fim = this.formatarDataBr(this.dashboard.periodo.data_fim)
      return `${inicio} — ${fim}`
    },
  },
  mounted() {
    const self = this
    self.setLoader(40)
    self.getConfiguracao()
  },
  methods: {
    formatarDataBr(dataIso) {
      if (!dataIso) {
        return ''
      }
      const [ano, mes, dia] = dataIso.split('-')
      return `${dia}/${mes}/${ano}`
    },
    classeStatus(status) {
      const mapa = {
        excelente: 'pill-excelente',
        atencao: 'pill-atencao',
        critico: 'pill-critico',
        neutro: 'pill-neutro',
      }
      return mapa[status] || 'pill-neutro'
    },
    rotuloStatus(status) {
      const mapa = {
        excelente: 'Excelente',
        atencao: 'Atenção',
        critico: 'Crítico',
        neutro: '—',
      }
      return mapa[status] || '—'
    },
    getEstatisticas() {
      const self = this
      const endpoint = `${self.$store.state.api}estatisticas/`

      self.dashboard = null

      if (self.pesquisa.data_inicio === '' || self.pesquisa.data_fim === '') {
        self.$message(null, 'Por favor, informe a data inicial e a data final', 'error')
        return
      }

      const dataInicial = new Date(self.pesquisa.data_inicio)
      const dataFinal = new Date(self.pesquisa.data_fim)
      const diferencaEmDias = Math.ceil(Math.abs(dataFinal - dataInicial) / (1000 * 60 * 60 * 24))

      if (diferencaEmDias > 30) {
        self.$message('Período muito longo', `O período máximo é de 30 dias. Você selecionou ${diferencaEmDias} dias.`, 'error')
        return
      }

      self.carregando = true
      axios
        .post(endpoint, self.pesquisa)
        .then(response => {
          self.dashboard = response.data
          self.carregando = false
        })
        .catch(error => {
          self.carregando = false
          self.$message(null, error.response?.data || error, 'error')
        })
    },
    getPdf() {
      const self = this
      const endpoint = `${self.$store.state.api}pdf_estatisticas/`

      self.$loading(true)
      axios
        .post(endpoint, self.pesquisa, { responseType: 'blob' })
        .then(response => {
          const arquivoPdf = new Blob([response.data], { type: 'application/pdf' })
          window.open(window.URL.createObjectURL(arquivoPdf), '_blank')
          self.$loading(false)
        })
        .catch(() => {
          self.$loading(false)
          self.$message(null, 'Erro ao gerar PDF', 'error')
        })
    },
    getExcel() {
      const self = this
      const endpoint = `${self.$store.state.api}excel_estatisticas/`

      self.$loading(true)
      axios
        .post(endpoint, self.pesquisa)
        .then(response => {
          window.open(`${self.$store.state.url}excel_estatisticas?k=${encodeURIComponent(response.data)}`, '_blank')
          self.$loading(false)
        })
        .catch(error => {
          self.$loading(false)
          self.$message(null, 'Erro ao exportar Excel', 'error')
        })
    },
    getConfiguracao() {
      const self = this
      const endpoint = `${self.$store.state.api}configuracoes/`
      axios
        .get(endpoint)
        .then(response => {
          self.configuracao = response.data.data[0]
          self.setLoader(60)
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    setSemana() {
      const self = this
      const agora = new Date()
      self.pesquisa.data_inicio = self.formatDate(new Date(agora.setDate(agora.getDate() - agora.getDay())))
      self.pesquisa.data_fim = self.formatDate(new Date(agora.setDate(agora.getDate() + (6 - agora.getDay()))))
    },
    setAno() {
      const self = this
      const agora = new Date()
      self.pesquisa.data_inicio = self.formatDate(new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - 30))
      self.pesquisa.data_fim = self.formatDate(agora)
    },
    formatDate(data) {
      const ano = data.getFullYear()
      const mes = String(data.getMonth() + 1).padStart(2, '0')
      const dia = String(data.getDate()).padStart(2, '0')
      return `${ano}-${mes}-${dia}`
    },
    setLoader(quantidade) {
      const self = this
      let carregado = 0
      const intervalo = setInterval(() => {
        self.loader++
        carregado++
        if (carregado === quantidade) {
          clearInterval(intervalo)
        }
      }, 15)
    },
  },
}
</script>
<style scoped>
/* Tema claro (padrão) — tokens do Vuexy */
.estatisticas-dashboard {
  --panel: #ffffff;
  --stroke: #ebe9f1;
  --stroke-soft: #f1f0f7;
  --ink: #5e5873;
  --body: #6e6b7b;
  --muted: #a8a5b3;
  --bar-track: rgba(94, 88, 115, 0.1);
  --shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  --shadow-hover: 0 10px 30px 0 rgba(34, 41, 47, 0.18);
  padding: 2px 0;
  color: var(--body);
}

/* Tema dark (Vuexy body.dark-layout) — override dos tokens */
body.dark-layout .estatisticas-dashboard {
  --panel: #283046;
  --stroke: #3b4253;
  --stroke-soft: #3b4253;
  --ink: #d0d2d6;
  --body: #b4b7bd;
  --muted: #676d7d;
  --bar-track: rgba(255, 255, 255, 0.1);
  --shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
  --shadow-hover: 0 10px 30px 0 rgba(0, 0, 0, 0.45);
}

/* Toolbar */
.dash-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 16px;
  box-shadow: var(--shadow);
}
.dash-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dash-field label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
  margin: 0;
}
.dash-input {
  min-width: 170px;
}
.dash-spacer {
  margin-left: auto;
}
.dash-btn {
  border: 0;
  border-radius: 8px;
  padding: 9px 16px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
}
.dash-btn i {
  margin-right: 4px;
}
.dash-btn-ghost {
  background: transparent;
  border: 1px solid #7367f0;
  color: #7367f0;
}
.dash-btn-danger {
  background: #ea5455;
}
.dash-btn-success {
  background: #28c76f;
}
.dash-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Cabeçalho */
.dash-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  padding: 22px 24px;
  margin-bottom: 16px;
  box-shadow: var(--shadow);
}
.dash-header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--ink);
  margin: 0;
}
.dash-header p {
  color: var(--muted);
  margin: 4px 0 0;
  font-size: 0.9rem;
}
.dash-header-date {
  text-align: right;
  white-space: nowrap;
}
.dash-header-date span {
  display: block;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
}
.dash-header-date strong {
  color: var(--ink);
  font-size: 1rem;
}

/* KPIs */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
.kpi-card {
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: var(--shadow);
}
.kpi-label {
  display: block;
  font-size: 0.72rem;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 12px;
}
.kpi-value {
  font-size: 2.3rem;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.kpi-total .kpi-value {
  color: #7367f0;
}
.kpi-fila .kpi-value {
  color: #ff9f43;
}
.kpi-ausentes .kpi-value {
  color: #ea5455;
}
.kpi-jornada .kpi-value {
  color: #28c76f;
}

/* Painéis */
.panel {
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  padding: 20px 22px;
  box-shadow: var(--shadow);
}
.panel h2 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 16px;
}
.panel-empty {
  color: var(--muted);
  font-size: 0.9rem;
  margin: 0;
}
.dash-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
.dash-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Tabela de tempos */
.tempos-table {
  width: 100%;
  border-collapse: collapse;
}
.tempos-table th {
  text-align: left;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
  font-weight: 600;
  padding: 0 0 12px;
  border-bottom: 1px solid var(--stroke);
}
.tempos-table td {
  padding: 13px 0;
  border-bottom: 1px solid var(--stroke-soft);
  color: var(--ink);
}
.tempos-table tr:last-child td {
  border-bottom: 0;
}
.tempos-table .col-tempo {
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

/* Pills de status */
.pill {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
}
.pill-excelente {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.16);
}
.pill-atencao {
  color: #ff9f43;
  background: rgba(255, 159, 67, 0.16);
}
.pill-critico {
  color: #ea5455;
  background: rgba(234, 84, 85, 0.16);
}
.pill-neutro {
  color: var(--muted);
  background: rgba(130, 134, 139, 0.16);
}

/* Perfil de demanda */
.demanda-item {
  margin-bottom: 14px;
}
.demanda-item:last-child {
  margin-bottom: 0;
}
.demanda-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.demanda-top .nome {
  color: var(--ink);
  font-weight: 600;
}
.demanda-top .qtd {
  color: var(--muted);
}
.bar-track {
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}
.bar-fill {
  height: 100%;
  border-radius: 999px;
  background: #7367f0;
  min-width: 6px;
}

/* Perfil de prioridades */
.prioridade-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid var(--stroke-soft);
  color: var(--ink);
}
.prioridade-item:last-child {
  border-bottom: 0;
}
.prioridade-item .qtd {
  font-weight: 700;
}

/* Situação */
.situacao-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 14px;
}
.situacao-tile {
  border-radius: 12px;
  padding: 16px 18px;
  border: 1px solid transparent;
}
.situacao-tile .tile-label {
  display: block;
  font-size: 0.85rem;
  margin-bottom: 8px;
}
.situacao-tile .tile-value {
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.tile-pendentes {
  background: rgba(255, 159, 67, 0.12);
  border-color: rgba(255, 159, 67, 0.3);
}
.tile-pendentes .tile-label,
.tile-pendentes .tile-value {
  color: #ff9f43;
}
.tile-evadidas {
  background: rgba(234, 84, 85, 0.12);
  border-color: rgba(234, 84, 85, 0.3);
}
.tile-evadidas .tile-label,
.tile-evadidas .tile-value {
  color: #ea5455;
}
.tile-finalizados {
  background: rgba(40, 199, 111, 0.12);
  border-color: rgba(40, 199, 111, 0.3);
}
.tile-finalizados .tile-label,
.tile-finalizados .tile-value {
  color: #28c76f;
}
.tile-cancelados {
  background: rgba(130, 134, 139, 0.1);
  border-color: var(--stroke);
}
.tile-cancelados .tile-label {
  color: var(--muted);
}
.tile-cancelados .tile-value {
  color: var(--ink);
}

/* Carregando (spinner na busca) */
.dash-loading {
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  box-shadow: var(--shadow);
  padding: 60px 20px;
  text-align: center;
  color: var(--muted);
}
.dash-spinner {
  width: 42px;
  height: 42px;
  margin: 0 auto 16px;
  border: 4px solid var(--stroke);
  border-top-color: #7367f0;
  border-radius: 50%;
  animation: dash-spin 0.8s linear infinite;
}
.dash-loading p {
  margin: 0;
  font-size: 13px;
}
@keyframes dash-spin {
  to { transform: rotate(360deg); }
}

/* Estado vazio */
.dash-empty {
  background: var(--panel);
  border: 1px solid var(--stroke);
  border-radius: 14px;
  padding: 40px;
  text-align: center;
  color: var(--muted);
}

/* Efeito visual ao passar o mouse nos cards */
.kpi-card,
.panel,
.situacao-tile {
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.kpi-card:hover,
.panel:hover,
.situacao-tile:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

/* Responsivo */
@media (max-width: 992px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .dash-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .kpi-grid {
    grid-template-columns: 1fr;
  }
}
</style>
